var MDB = window.MDB || {};;
MDB.IoFormat = MDB.IoFormat || {};

(function ($, MDB) {
    $.extend(MDB.IoFormat, {
        getFormatItemDefinitions: function(formatId, ajaxOpts){
            var baseOpts = {
                url: sprintf('/Settings/IOFormat/%s/IOItem/ListIOItemsDefinitions', formatId)
            };
            
            if (!ajaxOpts) {
                ajaxOpts = baseOpts;
            }
            
            ajaxOpts = _.merge(ajaxOpts, baseOpts);
            
            return $.ajax(ajaxOpts);
        },
        bootIndex: function (formSelector) {
            var dropdown = $('#Id');
            var submit = $('#edit-io-format');
            var clone = $('#clone-io-format');

            submit.click(function () {
                var id = dropdown.val();
                window.location.href = submit.data('action') + '/' + id;
            });

            clone.click(function () {
                var id = dropdown.val();
                $.post(clone.data('action'), {id: id}).done(function (response) {
                    window.location.href = response.redirect;
                });
            });
        }
    });
})(jQuery, MDB);